import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DashboardLayout from './DashboardLayout';

function LogViewer() {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [searchDate, setSearchDate] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const logsPerPage = 30;

    const fetchLogs = async () => {
        setLoading(true);
        setError('');
        try {
            const response = await axios.get('/api/logviewer');
            setLogs(response.data.logs || []);
        } catch (err) {
            setError('Failed to load logs.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogs();
    }, []);

    const formatLogMessage = (log) => {


        console.log("RAW LOG:", log);


        const parts = log.split('||').map(p => p.trim());


        console.log("PARTS:", parts);


        if (parts.length < 2) {

            return log;

        }


        const type = parts[1];

        const details = parts.slice(2)

            .filter(p => !p.startsWith("IP:"))

            .join(' | ');


        console.log("TYPE:", type);

        console.log("DETAILS:", details);

        if (type.includes('LOGIN SUCCESS')) {
            return `User Logged In: ${details}`;
        } else if (type.includes('LOGIN FAILED')) {
            return `Login Failed: ${details}`;
        } else if (type.includes('LOGOUT')) {
            return `User Logged Out: ${details}`;
        }
        return null; // hide everything else
    };
    const filteredLogs = logs.filter(item => {
        if (!searchDate) return true;

        return item.log.includes(searchDate);
    });
    const indexOfLastLog = currentPage * logsPerPage; const indexOfFirstLog = indexOfLastLog - logsPerPage;
    const currentLogs = filteredLogs.slice(
        indexOfFirstLog,
        indexOfLastLog);
    const totalPages = Math.ceil(
        filteredLogs.length / logsPerPage);
    const paginationButtonStyle = {
        padding: "7px 14px",
        borderRadius: "20px",
        border: "1px solid #1a4a2e",
        backgroundColor: "var(--bs-body-bg)",
        color: "#1a4a2e",
        cursor: "pointer",
        fontSize: "13px",
        transition: "0.3s"
    };

    return (
        <DashboardLayout>
            <div style={{ padding: '20px' }}>
                <h2 style={{ marginBottom: '20px', color: '#1a4a2e' }}>Application Log Viewer</h2>

                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "15px"
                }}>
                    <input
                        type="text"
                        placeholder="Search by date (DD-MM-YYYY)"
                        value={searchDate}
                        onChange={(e) => {
                            setSearchDate(e.target.value);
                            setCurrentPage(1);
                        }}
                        style={{
                            width: "250px",
                            padding: "8px",
                            border: "1px solid var(--bs-border-color)",
                            borderRadius: "5px",
                            background: "var(--bs-body-bg)",
                            color: "var(--bs-body-color)"
                        }}
                    />
                </div>

                {error && <div style={{ color: 'red', marginBottom: '12px' }}>{error}</div>}

                {loading ? (
                    <p>Loading logs...</p>
                ) : (
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#1a4a2e', color: '#fff' }}>
                                <th style={{ padding: '10px', textAlign: 'left', width: '40px' }}>#</th>
                                <th style={{ padding: '10px', textAlign: 'left', width: '200px' }}>Date & Time</th>
                                    <th style={{ padding: '10px', textAlign: 'left' }}>Log Message</th>
                                    <th style={{ padding: '10px', textAlign: 'left' }}>IP Address</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.filter(item => {
                                const type = item.log.split('||')[1]?.trim() || '';
                                return type.includes('LOGIN SUCCESS') ||
                                    type.includes('LOGIN FAILED') ||
                                    type.includes('LOGOUT');
                            }).length === 0 ? (
                                <tr>
                                            <td colSpan="4" style={{ padding: '20px', textAlign: 'center', color: 'var(--bs-secondary-color)' }}>                                        No logs found
                                    </td>
                                </tr>
                            ) : (
                                        currentLogs.map((item, index) => {
                                            const parts = item.log.split('||').map(p => p.trim());

                                            const dateTime = parts[0] || '';

                                            const ipPart = parts.find(p => p.startsWith("IP:")); const IPAddress = ipPart ? ipPart.replace("IP:", "").trim() : "-";

                                            const message = formatLogMessage(item.log);
                                        return (
                                            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? 'var(--bs-tertiary-bg)' : 'var(--bs-body-bg)', borderBottom: '1px solid var(--bs-border-color)' }}>
                                                <td style={{ padding: '10px', color: 'var(--bs-body-color)' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', color: 'var(--bs-body-color)' }}>{dateTime}</td>
                                                <td style={{ padding: '10px', color: 'var(--bs-body-color)' }}>{message}</td>
                                                <td style={{ padding: '10px', color: 'var(--bs-body-color)' }}>{IPAddress}</td>
                                            </tr>
                                        );
                                    })
                            )}
                        </tbody>
                    </table>
                )}

                <div
                    style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px"
                    }}
                >
                    <button
                        onClick={() => setCurrentPage(1)}
                        disabled={currentPage === 1}
                        style={{
                            ...paginationButtonStyle,
                            opacity: currentPage === 1 ? 0.5 : 1,
                            cursor: currentPage === 1 ? "not-allowed" : "pointer"
                        }}
                    >
                        First
                    </button>

                    <button
                        onClick={() => setCurrentPage(p => p - 1)}
                        disabled={currentPage === 1}
                        style={{
                            ...paginationButtonStyle,
                            opacity: currentPage === 1 ? 0.5 : 1,
                            cursor: currentPage === 1 ? "not-allowed" : "pointer"
                        }}
                    >
                        Previous
                    </button>

                    <span style={{ fontSize: "14px", color: "var(--bs-body-color)", padding: "0 8px" }}>
                        Page {currentPage} of {totalPages}
                    </span>

                    <button
                        onClick={() => setCurrentPage(p => p + 1)}
                        disabled={currentPage === totalPages}
                        style={{
                            ...paginationButtonStyle,
                            opacity: currentPage === totalPages ? 0.5 : 1,
                            cursor: currentPage === totalPages ? "not-allowed" : "pointer"
                        }}
                    >
                        Next
                    </button>

                    <button
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                        style={{
                            ...paginationButtonStyle,
                            opacity: currentPage === totalPages ? 0.5 : 1,
                            cursor: currentPage === totalPages ? "not-allowed" : "pointer"
                        }}
                    >
                        Last
                    </button>
                </div>
            </div>
        </DashboardLayout>
    );
}

export default LogViewer;